import axios from 'axios'
import { Row } from './convertColumns'

async function fetchColumns(headers: any, factory_id: number): Promise<Row[]> {
  return axios.get(`/v0/factories/${factory_id}/equipments`, {
    headers: headers,
  })
    .then((res) => res.data)
    .catch((reason) => {
      throw reason
    })
}

export default fetchColumns
